import React from "react";
import {
  Row,
  Col,
  Container,
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  CardFooter
} from "shards-react";
import { useEffect, useState } from "react";
import api from "../common/api";
import { get_request } from "../common/axios";
import TopReferrals from "../common/TopReferrals";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from "@material-ui/core";
import Charts from "../../views/charts";
import colors from "../../utils/colors";

function getRandomColor() {
  var letters = "0123456789ABCDEF";
  var color = "#";
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}
const GroupedCard = ({ title, referralData, url }) => {
  return (
    <Card small>
      <CardHeader className="border-bottom px-2 py-1">
        <h6 className="m-0" style={{ fontSize: 14 }}>
          {title} ({referralData.length})
        </h6>
        <div
          className="block-handle"
          onClick={() => {
            window.location.href = url;
          }}
        />
      </CardHeader>

      <CardBody className="p-0">
        <ListGroup
          small
          flush
          className="list-group-small h-auto"
          style={{ maxHeight: "30vh", overflowY: "scroll" }}
        >
          {referralData &&
            referralData.map((item, idx) => (
              <ListGroupItem key={idx} className="px-2 py-1">
                <div className="text-semibold">
                  {item.plate} - {item.description} - ({item.last_km} km)
                </div>
                <div className="d-flex">
                  {item.vehicleColor && (
                    <div>
                      Color: {item.vehicleColor ? item.vehicleColor.name : ""}
                    </div>
                  )}
                  {item.custom_text && (
                    <div>
                      {item.custom_text.title}: {item.custom_text.value}
                    </div>
                  )}
                </div>
              </ListGroupItem>
            ))}
        </ListGroup>
      </CardBody>

      <CardFooter className="border-top">
        <Row>
          {/* View Full Report */}
          <Col className="text-right view-report"></Col>
        </Row>
      </CardFooter>
    </Card>
  );
};
function VehiclesGroupedByState() {
  const [data, setData] = useState([]);
  const [showPanel, setShowPanel] = useState([
    "DISPONIBLE",
    "ASIGNADO",
    "MULETO"
  ]);
  const [panels, setPanels] = useState([]);
  const getDashboard = () => {
    get_request(api.vehicles().grouped(1)).then(res => {
      if (res.status === 200) {
        setData(res.data);
        setPanels(res.data.map(val => val.name));
      }
    });
  };

  useEffect(() => getDashboard(), []);

  let data_filtered = data.filter(val => showPanel.includes(val.name));
  if (data_filtered.length === 0)
    return (
      <Container fluid className="main-content-container px-4 pb-4"></Container>
    );
  data_filtered = data_filtered.sort(
    (a, b) => b.vehicles.length - a.vehicles.length
  );
  let chart = {
    labels: data_filtered.map(val => val.name),
    datasets: [
      {
        data: data_filtered.map(val => val.vehicles.length),
        icons: [],
        backgroundColor: data_filtered.map(val =>
          val.color ? val.color : getRandomColor()
        )
      }
    ]
  };
  return (
    <Container fluid className="main-content-container px-4 py-4">
      <Row className="mb-4">
        <Col lg="4">
          <Typography variant="h6" className="mt-2">
            Vehículos por estado
          </Typography>
          <FormControl style={{ overflow: "hidden", maxWidth: 200 }}>
            <InputLabel style={{ fontSize: "0.75rem" }}>Estados</InputLabel>
            <Select
              id="panels"
              name="panels"
              multiple
              value={showPanel}
              onChange={e => {
                setShowPanel(e.target.value);
              }}
              style={{ fontSize: "0.75rem" }}
            >
              {panels.map((panel, idx) => (
                <MenuItem
                  key={`panel-${idx}`}
                  id={`panel-${idx}`}
                  value={panel}
                  style={{ fontSize: "0.75rem" }}
                >
                  {panel}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Col>
        <Col lg="4">
          <Charts
            title="Vehículos por estado"
            chartData={chart}
            withlabels
            withTitle={false}
          />
        </Col>
      </Row>
      <Row>
        {data_filtered.map((val, idx) => {
          const url =
            val.fleet_owner == 1
              ? `/ac-vehicles?state=${val.name}`
              : `/vehicles`;
          return (
            <Col lg="6" sm="12" className="my-4">
              <GroupedCard
                referralData={val.vehicles}
                title={val.name}
                url={url}
              />
            </Col>
          );
        })}
      </Row>
    </Container>
  );
}

export default VehiclesGroupedByState;
